import { GenericServices } from "./generic.services";
import CompanyURI from "../common/uri/company.uri.constants";
import { ApiResponse } from "../models/app-configuration";
import { CompanyEditModel } from "../models/person/company.model";
import { AxiosPromise } from "axios";

class CompanyServices extends GenericServices {
	initNewCompany(): Promise<any> {
		return this.executeSelectingPost(
			{},
			CompanyURI.initData
		).then((res: ApiResponse) => {
			return res.isSuccess ? Promise.resolve(res.data) : Promise.reject(res.message);
		}).catch(err => {
			return Promise.reject(err);
		})
	}

	insertCompany<TResult>(model: CompanyEditModel): AxiosPromise<TResult> {
		return this.executeCreating(model, CompanyURI.saveCompany).
			then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(response.data)
					: Promise.reject(response)
			})
			.catch(error => Promise.reject(error))
	}

	getCompanyEditById(id: number) {
		let path = CompanyURI.getCompanyDetail;
		// if (loadTabs) {
		// 	path += "?load-tab=" + loadTabs;
		// }
		return super.executeSelectBy({ id }, path)
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
	}

	updatePerson<TResult>(originEntity: CompanyEditModel, entity: CompanyEditModel): AxiosPromise<TResult> {
		const clonedOriginEntity = JSON.parse(JSON.stringify(originEntity));
		const clonedEntity = JSON.parse(JSON.stringify(entity));

		let path = CompanyURI.updateCompany.replace(':id', entity.CompanyGeneral.Id.toString());
		return this.executeUpdatingCompare(clonedOriginEntity, clonedEntity, path)
			.then((response: ApiResponse) => {
				return response.isSuccess
					? Promise.resolve(response.data)
					: Promise.reject(response)
			})
			.catch(error => Promise.reject(error))
	}

	getCompanyPreviewById(id: number, tabs?: string) {
		return super.executeSelectingNotEncode({
			tabs: tabs || '*'
		}, CompanyURI.getCompanyPreview.replace(":id", id.toString()))
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
	}

	getLinkedProperties(companyId: number, params = {}) {
		return super.executeSelectingNotEncode(params, CompanyURI.linkedProperties.replace(":id", companyId.toString()))
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
	}

	getPropertyProposal(companyId: number, params = {}) {
		return super.executeSelectingNotEncode(params, CompanyURI.propertyProposal.replace(":id", companyId.toString()))
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
	}

	getDemandProposal(companyId: number, params = {}) {
		return super.executeSelectingNotEncode(params, CompanyURI.demandProposal.replace(":id", companyId.toString()))
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
	}

	getAutoCompleteName(startName: string, params = {}) {
		return super.executeSelectingNotEncode(params, CompanyURI.autoComplete.replace(":startName", startName))
			.then((response: ApiResponse) => {
				if (response.isSuccess) {
					return Promise.resolve(response.data);
				}
				else return Promise.reject(response.message);
			})
			.catch(ex => {
				console.log(ex);
				return Promise.reject(ex);
			})
    }
    
    getCompanyInfo(vat: string) {
        return super.executeSelectingNotEncode({vat}, CompanyURI.information)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

    generateCBE(payload) {
        return super.executeSelectingPost(payload, CompanyURI.generateCBE)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                else return Promise.reject(response.message);
            })
            .catch(ex => {
                console.log(ex);
                return Promise.reject(ex);
            })
    }

}

export default new CompanyServices();